import DisplayHtml from './display-html';

export default DisplayHtml;
